export type RegistrationDetailsTab = 'info' | 'billing'

export interface RegistrationDetailsTabsRecord {
  is_official_budget_line?: boolean | null
}

/**
 * The tabs a registration shows. SN-8480 — a Team Rep's own Team Budget line has no
 * player and answered no form, so it has nothing for Registration Info: only its
 * Billing Schedule. Every other registration shows both.
 */
export const getAvailableTabs = (
  details?: RegistrationDetailsTabsRecord | null
): RegistrationDetailsTab[] =>
  details?.is_official_budget_line ? ['billing'] : ['info', 'billing']

/**
 * SN-8480 — the URL a line's page settles on: its `/billing` path, with every query
 * param kept (`registration_id` included) except `tab`, which the page reads before
 * the path and would otherwise send it back to Info.
 */
export const normalizeLineTabUrl = (
  pathname: string,
  search: string
): string => {
  const base = pathname.replace(/\/(info|billing)\/?$/, '')
  const params = new URLSearchParams(search)
  params.delete('tab')
  const query = params.toString()

  return `${base}/billing${query ? `?${query}` : ''}`
}
